module.exports = __webpack_public_path__ + "img/home_news_default.20462792.png";